import { PaperClipIcon } from '@heroicons/react/20/solid';
import { useAppSelector } from 'hooks/store';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { ChangeLogoModal, ConfirmRemoveLogo } from '../ChangeModals';

export const LogoField = () => {
  const logo = useAppSelector((state) => state.account.account?.logo);
  const [openEdit, setOpenEdit] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);

  return (
    <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 reviews-link items-center">
      <ConfirmRemoveLogo open={openRemove} setOpen={setOpenRemove} />
      <ChangeLogoModal open={openEdit} setOpen={setOpenEdit} />
      <dt className="text-sm font-medium text-gray-500">
        <FormattedMessage id="logo" />
      </dt>
      <dd className="mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0">
        <div className="flex-grow truncate">
          {logo?.links?.preloader ? (
            <div className="divide-y divide-gray-100 rounded-md border border-gray-200">
              <div className="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                <div className="flex w-0 flex-1 items-center">
                  <PaperClipIcon
                    className="h-5 w-5 flex-shrink-0 text-gray-400"
                    aria-hidden="true"
                  />
                  <div className="ml-4 flex min-w-0 flex-1 gap-2">
                    <span className="truncate font-medium">{logo.name}</span>
                    <span className="flex-shrink-0 text-gray-400">{logo.size}</span>
                  </div>
                </div>
                <div className="ml-4 flex flex-shrink-0 space-x-4">
                  <button
                    type="button"
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                    className="rounded-md bg-white font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    <FormattedMessage id="update" />
                  </button>
                  <span className="text-gray-200" aria-hidden="true">
                    |
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      setOpenRemove(true);
                    }}
                    className="rounded-md bg-white font-medium text-gray-900 hover:text-gray-800"
                  >
                    <FormattedMessage id="remove" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            'No'
          )}
        </div>
        {!logo?.links?.preloader && (
          <span className="ltr:ml-4 rtl:mr-4 flex-shrink-0">
            <button
              onClick={() => {
                setOpenEdit(true);
              }}
              data-testId="cypress-change-media"
              className="rounded-md bg-white font-medium text-indigo-600 md:hover:text-indigo-500 md:focus:outline-none md:focus:ring-2 md:focus:ring-indigo-500 md:focus:ring-offset-2"
            >
              <FormattedMessage id="edit" />
            </button>
          </span>
        )}
      </dd>
    </div>
  );
};
